import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AgreementService } from '../data-access/agreement.service';

/*
 * This guard is used to redirect the user to the appropriate page
 * if they have not yet accepted the required or optional agreements.
 *
 */

export const requiredAgreementsGuard = () => {
  const agreementService = inject(AgreementService);
  const router = inject(Router);

  return agreementService.listRequiredAgreements().pipe(
    map((newAgreements) => {
      if (
        newAgreements.length > 0 ||
        agreementService.requiredAgreements.length > 0
      ) {
        agreementService.requiredAgreements = [
          ...agreementService.requiredAgreements,
          ...newAgreements,
        ];
        agreementService.nextRequiredAgreement$.next(
          agreementService.requiredAgreements[0]
        );
        return router.parseUrl('/login/terms');
      }
      return true;
    }),
    catchError(() => of(router.parseUrl('/ServerError')))
  );
};
